import { userPreferencesApi } from './userPreferencesApiBase';
import { UserPreferencesView } from './types';

export const userPreferencesMutationsApi = userPreferencesApi.injectEndpoints({
  endpoints: (builder) => ({
    // Create or update the signed-in user's saved default Centers
    saveMyPreferences: builder.mutation<UserPreferencesView, { defaultCenters: string[] }>({
      query: (body) => ({
        url: 'UserPreferences/mine',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['UserPreferences'],
    }),
  }),
});

export const { useSaveMyPreferencesMutation } = userPreferencesMutationsApi;
